import * as R from 'ramda';
import React from 'react';
import copy from '../../assets/text/copy.json';

const replaceAll = (str, find, replacer) => str.split(find).join(replacer);

export function text(params, ...rest) {
  const path = R.split('.')(params);
  const str = R.path(path)(copy) || '';
  const values = [...rest];
  if (values && values.map) {
    return values.reduce((acc, val, i) => replaceAll(acc, `$_${i + 1}`, val), str);
  }
  return str;
}
function Text({ bundle }) {
  const t = text(bundle);
  return <>{t}</>;
}
export default Text;
